module.exports = __webpack_public_path__ + "respect.3Ak4PTx_.svg";